import { useRouter } from 'next/router';
import {
  isItUndefined,
  isLinkAbsolute,
  removeNbsp,
  replaceOnDocument,
  retCountText,
  retCountTitle,
  stripHtml,
  noTruncateText,
  getTarget,
} from '../../util/DataUtil';
import { removeTags } from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import Link from 'next/link';

const ResourceLatest = ({ latest, title, onChipClick }) => {
  const router = useRouter();
  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // only execute all the code below in client side
      if (typeof window !== 'undefined') {
        // Handler to call on window resize
        function handleResize() {
          // Set window width/height to state
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
      }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const renderCategories = (categories, timeToRead) => {
    if (!categories) {
      return;
    }

    let ret = [];
    let split = categories.split(', ');

    split.forEach((item, index) => {
      ret.push(
        <span
          key={`category-${item || index}`}
          // onClick={(event) => onChipClick(event, [{name : item}])}
        >
          {index !== 0 ? ', ' : ''}
          {item}
          {timeToRead ? ', ' : ''}
        </span>
      );
    });
    return ret;
  };

  const checkIfLeadExist = (item) => {
    if (!item?.field_template_blocks?.template_lead_block) {
      return;
    }
    return item?.field_template_blocks?.template_lead_block
      ?.field_template_lead_text[0]?.value;
  };

  const checkIfTitleExist = (item) => {
    if (item?.field_template_blocks?.template_title_block_type) {
      return item?.field_template_blocks?.template_title_block_type
        ?.field_template_title[0]?.value;
    } else if (
      item?.field_template_blocks?.hero_graphic_block_type
        ?.field_formatted_title
    ) {
      return removeNbsp(
        stripHtml(
          item?.field_template_blocks?.hero_graphic_block_type
            ?.field_formatted_title[0]?.value
        )
      );
    }
    return '';
  };

  const checkIfTextExist = (item) => {
    if (
      !item?.field_template_blocks?.template_text_block_type &&
      !item?.field_slug &&
      !item?.field_template_blocks?.hero_graphic_block_type
    ) {
      return;
    }

    return isItUndefined(item?.field_slug)
      ? isItUndefined(item?.field_slug)
      : item?.field_template_blocks?.template_text_block_type
            ?.field_template_text[0]?.value
        ? item?.field_template_blocks?.template_text_block_type
            ?.field_template_text[0]?.value
        : item?.field_template_blocks?.hero_graphic_block_type
            ?.field_description[0]?.value;
  };

  const renderLatest = () => {
    return latest?.map((item, index) => {
      return (
        <div key={`latest-${item?.objectID || item?.['url-alias'] || index}`} className={'item'}>
          <hr />
          <div className={'container'}>
            <span className={'read'}>
              {renderCategories(
                item?.field_content_type_templat[0]?.name,
                isItUndefined(item?.field_time_to_read)
              )}
              <span className="ml-5-small">
                {isItUndefined(item?.field_time_to_read)}
              </span>
            </span>
            <Link
              href={item['url-alias'].length !== 0 ? item['url-alias'] : '/'}
              passHref
            >
              <a
                className={'title span-resource-latest-link'}
                target={getTarget(item['url-alias'])}
              >
                {isItUndefined(item?.field_display_title)
                  ? isItUndefined(item?.field_display_title)
                  : noTruncateText(
                      checkIfTitleExist(item),
                      retCountTitle(size.width),
                      '...'
                    )}
              </a>
            </Link>
            <span className={'text'}>
              {checkIfTextExist(item)
                ? noTruncateText(
                    removeTags(checkIfTextExist(item)),
                    retCountText(size.width),
                    '...'
                  )
                : noTruncateText(
                    checkIfLeadExist(item),
                    retCountText(size.width),
                    '...'
                  )}
            </span>
            <div className={'categories'}>
              <span
                className={'second-category category-hover'}
                onClick={(event) =>
                  onChipClick(event, [
                    { name: item?.field_template_category[0]?.name },
                  ])
                }
              >
                {item?.field_template_category[0]?.name}
              </span>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className={'resource-latest'}>
      <div className={'inner-container'}>
        <span className={'page-sub'}>{title}</span>
        <div className={'latest'}>{renderLatest()}</div>
      </div>
    </div>
  );
};

export default ResourceLatest;
